// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
const window = window || (global || {}).window;

export { window };
